/* Model */
class EventModel extends App.Models.BaseModel {
    modelUrl = 'Event';
}

App.Models.Event = EventModel;

/* Collection */
class EventCollection extends App.Collections.BaseCollection {
    url = 'Event';
    model = App.Models.Event;
}

App.Collections.Events = EventCollection;
